module.exports = __webpack_public_path__ + "img/jshangxin.17a671fc.gif";